import './LastResults.scss';
import fairness from '../../assets/icons/fairness.svg';
import { Ball } from '../../platform/components/ball/Ball';
import { gameStore, roundStore, useTranslation } from '../../platform/stores';
import { observer } from 'mobx-react';
import { IRound } from '../../platform/interfaces/round';
import { RoundStatus } from '../../platform/enums/round-status';

export const LastResults = observer(() => {
  const t = useTranslation();
  const { lastRounds } = gameStore;

  const openFairnessModal = (round: IRound) => {
    roundStore.setCheckHashRound(round);
  }

  return (
    <div className="last-results-component">
      {
        lastRounds.map((item) =>
          <div className="last-result-item" key={item.id}>
            <div className="round-info">
              <div className="round-id">{t('LAST_RESULTS_ROUND_ID', item.id)}</div>
              <div className="fairness">
                <img src={fairness} alt="Fairness icon" onClick={() => openFairnessModal(item)}/>
              </div>
            </div>
            <div className="hr"></div>
            <div className="actual-result">
              {
                item.status === RoundStatus.Finished
                  ?
                  <div className="balls">
                    {
                      item.numbers.map((number) =>
                        <div className="ball" key={'last-results' + item.id + '-' + number}>
                          <Ball number={number} className="last-result-number"/>
                        </div>
                      )
                    }
                  </div>
                  :
                  <></>
              }
              {
                item.status === RoundStatus.Pending
                  ?
                  <div className="next">{t('LAST_RESULTS_UPCOMING')}</div>
                  :
                  <></>
              }
              {
                item.status === RoundStatus.Started || item.status === RoundStatus.OnHold || item.status === RoundStatus.OnFinish
                  ?
                  <div className="next">{t('LAST_RESULTS_CURRENT')}</div>
                  :
                  <></>
              }
            </div>
          </div>
        )
      }
    </div>
  );
});
